import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';
import { UserDtoSchema } from '../contracts';

const GetLoginActivityResponseDtoSchema =
  PagePaginationResponseDtoSchema(UserDtoSchema);

export type GetLoginActivityRequestDto = PagePaginationRequestDto<{}>;
export type GetLoginActivityResponseDto = z.infer<
  typeof GetLoginActivityResponseDtoSchema
>;

export const getLoginActivity = (
  params: GetLoginActivityRequestDto,
  config?: AxiosRequestConfig<GetLoginActivityRequestDto>
) => {
  return api
    .get('/users/login-activity', { params, ...config })
    .then(responseContract(GetLoginActivityResponseDtoSchema));
};
